/** Format a lap/sector time in seconds as m:ss.mmm (or ss.mmm under a minute). */
export function formatLapTime(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds)) return '—';
  const sign = seconds < 0 ? '-' : '';
  const s = Math.abs(seconds);
  const mins = Math.floor(s / 60);
  const rem = s - mins * 60;
  if (mins > 0) {
    return `${sign}${mins}:${rem.toFixed(3).padStart(6, '0')}`;
  }
  return `${sign}${rem.toFixed(3)}`;
}

/** Format a signed delta in seconds, e.g. "+0.214" / "-1.032". */
export function formatDelta(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds)) return '—';
  return `${seconds >= 0 ? '+' : ''}${seconds.toFixed(3)}`;
}

/** Format a unix-seconds timestamp as a short local date-time. */
export function formatTimestamp(unixSeconds: number): string {
  return new Date(unixSeconds * 1000).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
